import "../../base.js";
import "./confirmation_modal/provider.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Views ??= {};
window.AppointmentBooking.SlotSuggester.Views.Reselector ??= {};
window.AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector ??= {};

const __ConfirmationModalPrior = AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.ConfirmationModal;

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.ConfirmationModal = class ConfirmationModal extends (
  AppointmentBooking.SlotSuggester.Views.Base
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.renderModalHeader = this.renderModalHeader.bind(this);
    this.renderProviders = this.renderProviders.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.whenModalLoaded = this.whenModalLoaded.bind(this);
    this.initializeModal = this.initializeModal.bind(this);
  }

  // @options.appendTo
  initialize(options = {}) {
    this.options = options;
    return super.initialize(options);
  }

  // EVENT HANDLERS

  handleSlotConfirmClick(event) {
    const slotId = jQuery(event.currentTarget).data("slot-id");
    const slot = this.assert.presence(this.slots.get(slotId), `Could not confirm slot ${slotId}. Slot not found.`);
    this.hide();
    return this.triggerEvent(this.Events.slot.confirm, slotId);
  }

  // RENDERING

  render() {
    super.render(...arguments);
    this.renderModalHeader();
    this.renderProviders();

    return this;
  }

  renderModalHeader() {
    return this.whenModalLoaded((modal) =>
      modal.setHeader(
        this.slots.length === 1
          ? this.I18n().confirmation_modal.header_confirm
          : this.I18n().confirmation_modal.header_choose.replace("%{count}", this.slots.length),
      ),
    );
  }

  renderProviders() {
    return this.$(".provider-container").each((_, container) => {
      const providerId = jQuery(container).data("provider-id");
      const slot = this.assert.presence(
        this.slots.find({ providerId }),
        `Could not find slot with provider id ${providerId}`,
      );

      return this.replaceContents(container, new this.Views.Provider({ model: slot }).render().el);
    });
  }

  // HELPER METHODS

  show() {
    this.whenModalLoaded((modal) => {
      jQuery(modal.container).addClass("--suggestion-selector-confirmation");
      if (this.options.appendTo) {
        jQuery(modal.container).appendTo(this.options.appendTo);
      } // Reappend to the target in case it has been removed
      this.render();
      return modal.show();
    });

    return this;
  }

  hide() {
    this.whenModalLoaded((modal) => modal.hide());

    return this;
  }

  // PRIVATE

  whenModalLoaded(fn) {
    return this.initializeModal().then(fn);
  }

  initializeModal() {
    if (!this.modalPromise) {
      const deferred = new jQuery.Deferred();

      jQuery.when().then(() => {
        const modal = new Modal({
          body: this.el,
          class: "appointment-booking-slot-picker-modal",
          appendTo: this.options.appendTo,
        }); // FIXME: This should use its own class, but is using this class because styling isn't present yet.
        return deferred.resolve(modal);
      });

      this.modalPromise = deferred.promise();
    }

    return this.modalPromise;
  }
};

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.ConfirmationModal.prototype.tagName = "div";
AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.ConfirmationModal.prototype.template =
  "reselector/suggestion_selector/confirmation_modal";
AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.ConfirmationModal.prototype.className =
  "appointment-booking-slot-reselector__suggestion-selector-confirmation-modal-content";
AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.ConfirmationModal.prototype.events = {
  "click [data-slot-id]": "handleSlotConfirmClick",
};

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.ConfirmationModal.get("slots", function () {
  return this.model.get("slots");
});

if (__ConfirmationModalPrior) {
  Object.assign(
    AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.ConfirmationModal,
    __ConfirmationModalPrior,
  );
}
